import script from "./AppHeaderFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderFaq.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderFaq.vue?vue&type=style&index=0&id=6681aa93&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6681aa93"]])

export default __exports__